import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components.native";
import { Image, View, Text, TouchableOpacity } from "react-native";
import images from "../../assets";

export const Wrap = styled(View)`
  position: absolute;
  bottom: 16px;
  left: 16px;
`;

export const MenuWrap = styled(View)``;

export const MenuButton = styled(TouchableOpacity)`
  border-radius: 100px;
  background-color: ${props => props.theme.colors.neutral2};
  width: 32px;
  height: 32px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  margin-top: 8px;
`;

export const MenuButtonTitle = styled(Text).attrs(() => ({
  numberOfLines: 1,
}))`
  font-size: 10px;
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 12px;
  margin-top: 8px;
  color: ${props => props.theme.colors.global6};
`;

export const ProfileIcon = styled(Image).attrs(() => ({
  source: images.ICO_PROFILE_ROUND,
}))`
  width: 100%;
  height: 100%;
`;

export const LanguageIcon = styled(Image).attrs(() => ({
  source: images.ICO_CIRCLE,
}))`
  width: 100%;
  height: 100%;
`;

export const Menu = styled(View)`
  position: absolute;
  left: 40px;
  bottom: 0;
  width: 240px;
  background-color: ${props => props.theme.colors.neutral2};
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
`;

export const MenuHeader = styled(Text)`
  font-weight: 16px;
  color: ${props => props.theme.colors.global2};
  padding: 16px;
`;

export const MenuHeaderInfo = styled(Text)`
  font-weight: 14px;
  color: ${props => props.theme.colors.global2};
  padding: 16px;
`;
